import React, {useEffect} from 'react';
import classes from './PageNotFound.module.scss'
import ReactGa from "react-ga";
import {HomeBreadcrumb} from "../../components/UI/HomeButton";
import {FormattedMessage} from "react-intl";

const PageNotFoundHook = (props) => {
    // const [state, setState] = useState({done: false, list_data: []});

    useEffect(() => {
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        window.scrollTo(0, 0);
    }, [props.location.pathname]);

    return (
        <>
            {/*Bread crumbs region*/}
            <section>
                <div className={["jbfs-wrapper"].join(' ')}>
                    <div className={["jbfs-breadcrumb-row",].join(' ')}>
                        <HomeBreadcrumb/>
                    </div>
                </div>
            </section>
            {/*Bread crumbs region*/}

            <section className={classes.PageNotFound_sectionHeader}>
                <div className={["jbfs-wrapper"].join(' ')}>
                    <div>
                        <h1><FormattedMessage id={"global.pagenotfound.title"} defaultMessage={"Page Not Found"}/></h1>
                        <p><FormattedMessage id={"global.pagenotfound.description"} defaultMessage={"Sorry, we can't find any page which you search"}/></p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PageNotFoundHook